export { email } from './email-config.js';
export { progressBar, progressBar1of2 } from './progress-bar-config.js';
export { firstName } from './first-name-config.js';
export { lastName } from './last-name-config.js';
export { address } from './address-config.js';
export { city } from './city-config.js';
export { country } from './country-config.js';
export { postCode } from './post-code-config.js';
export { currency } from './currency-config.js';
export { phone } from './phone-config.js';
export { consent } from './consent-config.js';
export { username } from './username-config.js';
export { state } from './state-config.js';
export { nestedConsents } from './nested-consent-config.js';
